/**
 * @generated SignedSource<<438b950136c645efb20d1bf5d5bc6d38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleReadingTimeContent$data = {
  readonly flag: string | null | undefined;
  readonly readingTime: number | null | undefined;
  readonly " $fragmentType": "articleReadingTimeContent";
};
export type articleReadingTimeContent$key = {
  readonly " $data"?: articleReadingTimeContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleReadingTimeContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleReadingTimeContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "readingTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flag",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "50a6fa670031f808c9e838a289c353e0";

export default node;
